export default function VinylRecord({
  size = 160,
  className = "",
  spin = true,
  label = "TWSS",
}) {
  return (
    <div
      aria-hidden="true"
      className={`relative rounded-full shrink-0 ${spin ? "animate-spin-slow" : ""} ${className}`}
      style={{
        width: size,
        height: size,
        background:
          "repeating-radial-gradient(circle at center, #0b0705 0px, #0b0705 2px, #201410 3px, #0b0705 4px)",
        boxShadow: "0 0 0 1px rgba(230,194,122,0.15), 0 20px 50px rgba(0,0,0,0.5)",
      }}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <div
          className="rounded-full bg-ember flex items-center justify-center"
          style={{ width: size * 0.36, height: size * 0.36 }}
        >
          <span
            className="font-display text-ink font-bold"
            style={{ fontSize: Math.max(9, size * 0.07) }}
          >
            {label}
          </span>
        </div>
      </div>
      <div
        className="absolute rounded-full bg-ink"
        style={{
          width: size * 0.05,
          height: size * 0.05,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      />
    </div>
  );
}
